<template>
  <div
    id="CourseBaseInformation"
    v-loading="loading"
    class=""
    style="padding: 0 20px"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="课程名称:" :required="true" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="办学形式:" :required="true" prop="types">
              <el-select
                v-model="form.types"
                placeholder="请选择"
                prop="types"
                @change="changeTypes"
              >
                <el-option
                  v-for="item in optionstype"
                  :key="item.typeCode"
                  :label="item.typeName"
                  :value="item.typeCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="课程代码:" :required="true" prop="code">
              <el-input v-model="form.code" :disabled="true"></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <div class="grid-content bg-purple">
              <el-form-item label="关联专业:" :required="true" prop="career">
                <!--              <el-input v-model="form.career"></el-input>-->
                <span>{{ form.career }}</span>
              </el-form-item>
            </div>
          </div></el-col
        >
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form-item label="建课时间:">
              <el-date-picker
                v-model="form.datetime"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="所属机构:" :required="true" prop="organ">
              <el-input v-model="form.organ" :disabled="true"></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="创建人:" :required="true" prop="creater">
              <el-input v-model="form.creater" :disabled="true"></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="推送机构:" :required="true" prop="pushOrgan">
              <el-checkbox-group v-model="form.pushOrgan">
                <el-checkbox
                  :label="item"
                  v-if="index > 5 ? isShow : isHide"
                  v-for="(item, index) in pushOrganList"
                  :key="item.id"
                  >{{ item.title }}</el-checkbox
                >
              </el-checkbox-group>
              <el-button type="primary" @click="more" v-if="mores"
                >选择更多</el-button
              >
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="封面上传:" :required="true">
              <el-upload
                class="avatar-uploader"
                :action="url + '/zkfz/courseDetail/addCover'"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">
                  上传图片只能是 JPG、JPEG、PNG 格式!建议尺寸为580px*320px
                </div>
              </el-upload>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="课程简介:"
              :required="true"
              prop="introduction"
            >
              <quill-editor
                ref="quillEditor"
                v-model="form.introduction"
                :options="options"
              >
                <div id="toolbar" slot="toolbar">
                  <button class="ql-bold" title="加粗">Bold</button>
                  <button class="ql-italic" title="斜体">Italic</button>
                  <button class="ql-underline" title="下划线">underline</button>
                  <button class="ql-strike" title="删除线">strike</button>
                  <button class="ql-blockquote" title="引用"></button>
                  <button class="ql-code-block" title="代码"></button>
                  <button
                    class="ql-list"
                    value="ordered"
                    title="有序列表"
                  ></button>
                  <button
                    class="ql-list"
                    value="bullet"
                    title="无序列表"
                  ></button>
                  <button class="ql-indent" value="+1" title="首行缩进">
                    indent
                  </button>
                  <select class="ql-header" title="段落格式">
                    <option selected>段落</option>
                    <option value="1">标题1</option>
                    <option value="2">标题2</option>
                    <option value="3">标题3</option>
                    <option value="4">标题4</option>
                    <option value="5">标题5</option>
                    <option value="6">标题6</option>
                  </select>
                  <select class="ql-size" title="字体大小">
                    <option value="10px">10px</option>
                    <option value="12px">12px</option>
                    <option value="14px">14px</option>
                    <option value="16px" selected>16px</option>
                    <option value="18px">18px</option>
                    <option value="20px">20px</option>
                  </select>
                  <select class="ql-font" title="字体">
                    <option value="SimSun" selected></option>
                    <option value="SimHei"></option>
                    <option value="Microsoft-YaHei"></option>
                    <option value="KaiTi"></option>
                    <option value="FangSong"></option>
                    <option value="Arial"></option>
                    <option value="Times-New-Roman"></option>
                    <option value="sans-serif"></option>
                  </select>
                  <select
                    class="ql-color"
                    value="color"
                    title="字体颜色"
                  ></select>
                  <select
                    class="ql-background"
                    value="background"
                    title="背景颜色"
                  ></select>
                  <select class="ql-align" value="align" title="对齐"></select>
                  <button class="ql-clean" title="还原"></button>
                </div>
              </quill-editor>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div
            class="grid-content bg-purple"
            style="text-align: center; padding-bottom: 30px"
          >
            <el-button type="primary" @click="submit('form')">确 定</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/courseware/course'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/assets/css/quill.css'
import { Quill, quillEditor } from 'vue-quill-editor' //调用编辑器

// 自定义字体大小
const Size = Quill.import('attributors/style/size')
Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px']
Quill.register(Size, true)

// 自定义字体类型
const fonts = [
  'simSum',
  'simHei',
  'Microsoft-YaHei',
  'KaiTi',
  'FangSong',
  'Arial',
  'Times-New-Roman',
  'sans-serif',
]
const Font = Quill.import('formats/font')
Font.whitelist = fonts
Quill.register(Font, true)

const Indent = Quill.import('formats/indent')
Indent.whitelist = [1]
Quill.register(Indent, true)

export default {
  name: 'CourseBaseInformation',
  components: {
    quillEditor,
  },
  data() {
    return {
      mores: true,
      isShow: false,
      isHide: true,
      loading: false,
      rules: {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        types: [{ required: true, message: '请选择', trigger: 'blur' }],
        code: [{ required: true, message: '请输入', trigger: 'blur' }],
        career: [{ required: true, message: '请输入', trigger: 'blur' }],
        organ: [{ required: true, message: '请输入', trigger: 'blur' }],
        creater: [{ required: true, message: '请输入', trigger: 'blur' }],
        pushOrgan: [{ required: true, message: '请选择', trigger: 'blur' }],
        introduction: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      form: {
        name: '',
        types: '',
        code: '',
        career: '',
        datetime: '',
        organ: '',
        creater: '',
        pushOrgan: [],
        introduction: '',
      },
      optionstype: [],
      pushOrganList: [],
      imageUrl: '',
      options: {
        placeholder: '请输入课程简介',
        theme: 'snow',
        modules: {
          toolbar: '#toolbar',
        },
      },
      fmId: '', //封面id
      mhmId: '', //机构id
      courseId: '',
      courseCode: '',
    }
  },
  methods: {
    submit(formData) {
      let pushId = ''
      for (let i = 0; i < this.form.pushOrgan.length; i++) {
        pushId += this.form.pushOrgan[i].id + ','
      }
      let obj = {}
      this.$refs[formData].validate((valid) => {
        if (!valid) {
          this.$message.error('请完善信息')
        } else if (
          this.imageUrl == '' ||
          this.imageUrl == undefined ||
          this.imageUrl == null
        ) {
          this.$message.error('请完善信息')
        } else {
          this.$router.push({
            name: 'CourseAdd', //tab所在的页面
            query: {
              tabs: 'second',
              videoTitle: this.form.name,
              learnTypeId: this.form.types,
              courseId: this.courseId,
              courseCode: this.courseCode,
              ctime: Math.round(
                new Date(this.form.datetime).getTime() / 1000
              ).toString(),
              mhmId: this.mhmId,
              uid: this.getUId,
              giveMhmIds: pushId,
              cover: this.fmId,
              videoBinfo: this.form.introduction,
              videoIntro: this.form.introduction,
            },
          })
          this.$router.go(0)
        }
      })
    },

    changeTypes() {
      //关联课程代码和专业
      api
        .getCourseList({
          courseName: this.form.name,
          educationTypeCodes: this.form.types,
        })
        .then(({ data }) => {
          data = data.data
          this.form.code = data[0].courseCode
          this.form.career = data[0].majorName
          this.courseId = data[0].courseId
          this.courseCode = data[0].courseCode
        })
    },

    more() {
      this.isShow = true
      this.mores = false
    },

    // 获取数据
    getList() {
      // this.loading = true
      this.getEducationType()
      this.getSchoolByUid()
      this.getUserByUid()
      this.getOrganLists()
    },

    // 获取办学形式
    getEducationType() {
      api.getEducationType().then(({ data }) => {
        data = data.data
        this.optionstype = data
      })
    },

    // 获取机构
    getSchoolByUid() {
      api.getSchoolByUid(this.getUId).then(({ data }) => {
        data = data.data
        this.mhmId = data.id
        this.form.organ = data.title
      })
    },

    // 获取创建人
    getUserByUid() {
      api.getUserByUid(this.getUId).then(({ data }) => {
        data = data.data
        this.form.creater = data.uname
      })
    },

    // 获取机构列表
    getOrganLists() {
      api.getOrganLists().then(({ data }) => {
        data = data.data
        this.pushOrganList = data.list
      })
    },

    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
      let formData = new FormData()
      formData.append('file', file.raw)
      api.addCover(formData).then(({ data }) => {
        this.fmId = data.data
      })
    },
    beforeAvatarUpload(file) {
      let types = ['image/jpeg', 'image/jpg', 'image/png']
      const isImage = types.includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImage) {
        this.$message.error('上传图片只能是 JPG、JPEG、PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isImage && isLt2M
    },
  },
  created() {
    this.getList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') || '4'
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-tabs__item {
  font-size: 12px;
}
/deep/.el-tabs__item {
  padding: 0 10px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  background-color: #e2e8f4;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #265480;
}
</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.ql-editor {
  min-height: 300px;
}
.el-tabs__item {
  font-size: 14px !important;
}
</style>
